__turbopack_context__.v({
  "wrapper": "markdown-module-scss-module__ss6hrG__wrapper",
});
